import React from 'react';
import { TextInputProps } from '@/components/common/text';
import { GlassFormInput } from '@/components/admin/redesign';

interface FormInputProps extends TextInputProps {
  label: string;
  error?: string;
  required?: boolean;
}

/**
 * Mobile FormInput is now a thin adapter over the theme-aware `GlassFormInput`
 * primitive. Existing call sites continue to work unchanged — the visual
 * treatment (label, focus border, error state) flows from `admin.formInput.*`.
 */
export const FormInput: React.FC<FormInputProps> = ({
  label,
  error,
  required = false,
  style,
  ...rest
}) => {
  return (
    <GlassFormInput
      label={label}
      error={error}
      required={required}
      inputStyle={style as any}
      {...rest}
    />
  );
};
